export default __webpack_public_path__ + "static/media/Funcionando.c6c7a71c.svg";